import styled from 'styled-components';

const DropDiv = styled.div`
  .active-state {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
  }
`;
export { DropDiv };
